var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"dark":"","color":"grey","icon":""},on:{"click":function($event){return _vm.openActionMenu()}}},[_c('v-icon',[_vm._v("mdi-menu")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }